import { Injectable } from "@angular/core";
import { OnboardingService } from "@edp-services/onboarding.service";
import {
    EOnboardingActions,
    SetCompleteOnboarding,
    SetOnboarding,
    SetOnboardingWhatsNew,
    WhatsNewRequestsAPIError,
} from "@edp-store/actions/onboarding.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, switchMap, tap } from "rxjs/operators";

@Injectable()
export class OnboardingEffects {
    @Effect()
    getOnboarding$ = this.actions$.pipe(
        ofType(EOnboardingActions.GetOnboarding),
        switchMap(() => this.onboardingService.getTourGuide().pipe(catchError((error: Error) => of(error)))),
        switchMap(response => {
            if (response instanceof Error || response instanceof Array) {
                return of(new SetOnboarding(null));
            }
            return of(new SetOnboarding({ ...response, page: response.step[0].anchorParentPage }));
        })
    );

    @Effect()
    getOnboardingWhatsNew$ = this.actions$.pipe(
        ofType(EOnboardingActions.GetOnboardingWhatsNew),
        switchMap(() =>
            this.onboardingService.getTourWhatsNew().pipe(catchError((error: Error) => of(new WhatsNewRequestsAPIError(error))))
        ),
        switchMap(response => {
            if (response instanceof Error || response instanceof WhatsNewRequestsAPIError || response instanceof Array) {
                return of(new WhatsNewRequestsAPIError(new Error("empty")));
            }
            return of(new SetOnboardingWhatsNew(response));
        })
    );

    @Effect({ dispatch: false })
    setCompleteOnboarding$ = this.actions$.pipe(
        ofType(EOnboardingActions.SetCompleteOnboarding),
        switchMap((action: SetCompleteOnboarding) =>
            this.onboardingService.setInteract(action.onboardingId, action.action).pipe(
                tap(() => {
                    if (action) {
                        return of(new SetOnboarding(null));
                    }
                    return of(null);
                }),
                catchError((error: Error) => of(error))
            )
        ),
    );

    constructor(private actions$: Actions, private onboardingService: OnboardingService) {}
}
